//myPageData
const en = {
    changeAvatarBtn: 'Change Avatar',
    myListingsTitle: 'Listings added ',
    logOutBtn: 'Log out',
    addMoreAdsBtn: 'View more',
    noAdsMessage: "You haven't added any ads yet",
    addNewAdBtnName: "Add listing",
    temporaryMessage: "Soon it will be possible to add an avatar here",
    btnNames: {
        addTelegram: 'Add Telegram',
        whyDoesThisMatter: 'Why does this matter?',
        activeAdsBtn: 'Active Listings',
        addAdBtn: 'Add Listing',
    },
    whyAddTelegramIsImportant: 'Add your Telegram so buyers can contact you faster — this increases your chances of a successful sale.',
}

const rus = {
    changeAvatarBtn: 'Изменить аватар', 
    myListingsTitle: 'Добавлено ', 
    logOutBtn: 'Выйти из приложения',
    addMoreAdsBtn: 'Посмотреть остальные',
    noAdsMessage: "Вы еще не добавили ни одного объявления",
    addNewAdBtnName: "Добавить",
    temporaryMessage: "Скоро тут можно будет добавить аватар",
    btnNames: {
        addTelegram: 'Добавить телеграм',
        whyDoesThisMatter: 'Почему это важно?',
        activeAdsBtn: 'Активные объявления',
        addAdBtn: 'Добавить объявление',
    },
    whyAddTelegramIsImportant: 'Добавьте Telegram, чтобы покупатели могли быстрее связаться с вами — это увеличивает шансы на успешную продажу.',
}

const hebrew = {
    changeAvatarBtn: 'שנה אווטאר',
    
    myListingsTitle: 'מודעות שהוספו',
    logOutBtn: 'התנתק',
    addMoreAdsBtn: 'צפה בעוד',
    noAdsMessage: 'עדיין לא הוספת מודעות',
    addNewAdBtnName: 'הוסף מודעה',
    temporaryMessage: 'בקרוב יהיה אפשר להוסיף אווטאר כאן',
    
    btnNames: {
        addTelegram: 'הוסף טלגרם',
        whyDoesThisMatter: 'למה זה חשוב?',
        activeAdsBtn: 'מודעות פעילות',
        addAdBtn: 'הוסף מודעה',
    },
    
    whyAddTelegramIsImportant: 'הוסף את הטלגרם שלך כדי שקונים יוכלו ליצור איתך קשר מהר יותר — זה מגדיל את הסיכויים למכירה מוצלחת.',
}

const choose = { en, rus, hebrew };

export default choose;